import { Routes, Route } from 'react-router-dom'
import IndexPage from './pages/IndexPage'
import BookingPage from './pages/BookingPage'
import MeetingPage from './pages/MeetingPage'
import LoginPage from './pages/LoginPage'

function App() {
  return (
    <Routes>
      <Route path="/" element={<IndexPage />} />
      <Route path="/control/backend/panel/booking" element={<BookingPage />} />
      <Route path="/meet/" element={<MeetingPage />} />
      <Route path="/login" element={<LoginPage />} />
    </Routes>
  )
}

export default App
